import {DomainStore} from 'shared/store';
import {observable, action, computed} from 'mobx';
import  _ from 'lodash';
import {auth, endpoints, types, t} from 'shared/core';
import {successAlert} from 'shared/tools';

class AdditionalCoverageState {
  store = new DomainStore();
  
  @observable currentEnrolment;
  @observable currentEligibilityRecord;
  @observable employee;
  @observable applyCoverageModalOpen = false;
  @observable declineCoverageModalOpen = false;
  @observable agreeToDeclineCoverage = false;
  @observable errors = {};

  receiveProps({currentEnrolment, currentEligibilityRecord, employee}) {
    this.currentEnrolment = currentEnrolment;
    this.currentEligibilityRecord = currentEligibilityRecord;
    this.employee = employee;
  }

  @action async submitDeclinedCoverage() {
    if (!this.agreeToDeclineCoverage) {
      this.errors = {
        agreeToDeclineCoverage: t('components.additional_coverage.You must agree to the terms of the waiver.')
      };
      return null;
    }

    const {model, errors} = await this.store.post(
      endpoints.ELIGIBILITY_RECORDS_DECLINE_COVERAGES.with(auth.employee.id),
      types.ELIGIBILITY_RECORD,
      { coverageTypes: [this.currentEligibilityRecord.coverageType] }
    );

    this.errors = errors;

    if (model) {
      this.currentEligibilityRecord.merge(model);
      this.closeModals();
      successAlert(t('components.additional_coverage.alerts.Additional coverage has been declined.'));
    }
  }

  @action openDeclineCoverageModal(carrier) {
    this.declineCoverageModalOpen = true;
  }

  @action openApplyForCoverageModal(carrier) {
    this.applyCoverageModalOpen = true;
  }

  @action closeModals() {
    this.declineCoverageModalOpen = false;
    this.applyCoverageModalOpen = false;
    this.agreeToDeclineCoverage = false;
    this.errors = {};
  }

  @action toggleDeclineCoverageAgreement(checked) {
    this.agreeToDeclineCoverage = true;
  }

  @action openDocument() {
    window.open(this.currentEligibilityRecord.evidenceOfInsurabilityFormUrl);
  }

  @computed get currentAdditionalCoverageVolumes() {
    return [
      {
        title: t('components.additional_coverage.Current Amount'),
        value: this.currentEligibilityRecord.currentVolume
      },
      {
        title: t('components.additional_coverage.Eligible Amount'),
        value: this.currentEligibilityRecord.eligibleVolume
      }
    ];
  }
}

export default AdditionalCoverageState;

